import { AxiosResponse } from 'axios';

import { requestMedia } from '../index';

//TODO WILL ADD TYPE
export function initFaceRecognitionRequest(payload: any): Promise<AxiosResponse<any>> {
  return requestMedia().post('/face-recognition', payload);
}
